module.exports = __webpack_public_path__ + "AdobeStock_161673435_shaded6.1_compressed.png?58ff058724f2aae6e5a9226809a8a08e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_161673435_shaded6.1_compressed.png
// module id = 103
// module chunks = 0